<script setup>
import PosteBtn from '@/components/fiche-aim/fiche-aim/poste-aim-btn.vue'
</script>

<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col class="pa-1" cols="auto" lg="3" v-for="p in postes" :key="p.posteAIMId">
        <poste-btn
          :poste="p"
          @click="$emit('input', p)"
          :disabled="exclude !== undefined && exclude.posteAIMId === p.posteAIMId"
          :selected="value !== undefined && value.posteAIMId === p.posteAIMId"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PosteAimPicker',
  props: {
    value: {
      type: Object,
      default: undefined,
    },
    exclude: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters({
      postes: 'posteAIM/getPostes',
    }),
  },
  methods: {
    ...mapActions({
      fetchPostes: 'posteAIM/fetchPostes',
    }),
  },
  watch: {
    exclude: function (toExclude) {
      if (toExclude !== undefined && this.value !== undefined && this.value.posteAIMId === toExclude.posteAIMId) {
        this.$emit('input', undefined)
      }
    },
  },
  mounted() {
    this.fetchPostes()
  },
}
</script>
